<template>
  <router-view class="layout-success page-max-width footer-max-width" />
</template>

<script>
  export default {};
</script>

<style lang="scss">
  .layout-success {
    .q-page {
      display: flex;
      align-items: center;
      justify-content: center;

      > section {
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .q-icon {
          margin: 20px 0;
        }

        h2 {
          margin: 20px;
          font-family: $common-font-family;
          font-size: 18px;
          font-weight: 900;
          line-height: 1.33;
          letter-spacing: normal;
        }
      }
    }

    .q-footer {
      @media screen and (min-width: $breakpoint-sm-max) {
        margin-bottom: 25px;
        box-shadow: none;
        > * {
          padding: 0 25px;
        }
      }
    }
  }
</style>
